/* eslint-disable react/prop-types */
import { Chip } from "@mui/material";
import {
  getMessageStatusMeta,
  getRecipientStatusMeta,
} from "../mailToolUtils";

const MailStatusChip = ({ statusId, type = "message", size = "small" }) => {
  const meta =
    type === "recipient"
      ? getRecipientStatusMeta(statusId)
      : getMessageStatusMeta(statusId);

  return (
    <Chip
      label={meta.label}
      color={meta.color}
      size={size}
      variant={meta.color === "default" ? "outlined" : "filled"}
      sx={{ fontWeight: 700, ...meta.sx }}
    />
  );
};

export default MailStatusChip;
